<ul ngbNav #nav="ngbNav" class="testdata-nav nav-tabs" style="border-bottom: 1px solid #a8a8a8;" [activeId]="activeTabId" (navChange)="changeTab($event)">
    <!-- Response Body -->
    <li title="Response Body Raw" [ngbNavItem]="0">
        <a ngbNavLink>Response Body</a>
        <ng-template ngbNavContent>
          <div style="display: flex;">
            <div style="width: 50%;">
              <div style="text-align: center; display: flex;">
                <h5 *ngIf="selectedTestData1.testDataSequence === 0">Primary</h5>
                <h5 *ngIf="selectedTestData1.testDataSequence > 0">Secondary {{ selectedTestData1.testDataSequence }} </h5>
                <i class="fas fa-clipboard clickable" style="margin: 8px 10px;" title="Copy to Clipboard" (click)="copyText1(selectedTestData1)"></i>
              </div>
              <div class="common-box overflow">
                <div *ngIf="selectedTestData1.responseBody!== null">
                  <ngx-json-viewer [json]="selectedTestData1.responseBody"></ngx-json-viewer>
                </div>
                <div *ngIf="selectedTestData1.responseBody === null">
                  No Response Data
                </div>
              </div>
            </div>
            <div style="width: 50%;">
              <div style="text-align: center; display: flex;">
                <h5 *ngIf="selectedTestData2.testDataSequence === 0">Primary</h5>
                <h5 *ngIf="selectedTestData2.testDataSequence > 0">Secondary {{ selectedTestData2.testDataSequence }} </h5>
                <i class="fas fa-clipboard clickable" style="margin: 8px 10px;" title="Copy to Clipboard" (click)="copyText2(selectedTestData2)"></i>
              </div>
              <div class="common-box overflow">
                <div *ngIf="selectedTestData2.responseBody!== null">
                  <ngx-json-viewer [json]="selectedTestData2.responseBody"></ngx-json-viewer>
                </div>
                <div *ngIf="selectedTestData2.responseBody === null">
                  No Response Data
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </li>
    <!-- Response Body -->
    <li title="Response Body" [ngbNavItem]="1">
      <a ngbNavLink>JSON Response Body </a>
      <ng-template ngbNavContent>
        <div class="app-container-body-compareBtn">
          <button
            *ngIf="!diffReport"
            mat-raised-button
            color="primary"
            (click)="compare()"
          >
            Click to get comparison
          </button>
        </div>
        <div *ngIf="diffReport" class="app-container-body-diffCard mt-2 mb-2">
          <h6 style="font-weight: 600; color: red; margin: 10px 3px;">Comparison will be show only for JSON response type</h6>
          <div class="app-container-body-diffCount">
            <div class="app-container-body-diffCount-box">
              <div class="app-container-body-diffCount-box-label">
                Total Difference Count : &nbsp;
              </div>
              <div class="app-container-body-diffCount-box-count">
                {{ diffReport.totalDiffCount }}
              </div>
            </div>
            <div class="app-container-body-diffCount-box missing">
              <div class="app-container-body-diffCount-box-label">
                Missing Properties : &nbsp;
              </div>
              <div class="app-container-body-diffCount-box-count">
                {{ diffReport.missingProperties }}
              </div>
            </div>
            <div class="app-container-body-diffCount-box unequal">
              <div class="app-container-body-diffCount-box-label">
                Unequal Values : &nbsp;
              </div>
              <div class="app-container-body-diffCount-box-count">
                {{ diffReport.unequalValues }}
              </div>
            </div>
            <div class="app-container-body-diffCount-box incorrect">
              <div class="app-container-body-diffCount-box-label">
                Incorrect Types : &nbsp;
              </div>
              <div class="app-container-body-diffCount-box-count">
                {{ diffReport.incorrectTypes }}
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-6 text-center">
            <span class="font-weight-bold">Executed on :</span>
            {{testCaseDetails1.execution?.executedOn | localDate}}
          </div>
          <div class="col-6 text-center">
            <span class="font-weight-bold">Executed on :</span>
            {{testCaseDetails2.execution?.executedOn | localDate}}
          </div>
        </div>

        <div class="app-container-body-comparison">
          <app-json-comparison
            [leftTree]="selectedTestData1.responseBody"
            [rightTree]="selectedTestData2.responseBody"
            [hideInitialStep]="false"
            [hideReport]="true"
            (differenceReport)="differenceReport($event)"
          ></app-json-comparison>
        </div>
      </ng-template>
    </li>
    <!-- Test Data -->
    <li title="Test Data" [ngbNavItem]="2">
      <a ngbNavLink>Test Data</a>
      <ng-template ngbNavContent>
        <div style="display: flex;">
          <div style="width: 50%;">
            <div style="text-align: center;">
              <h5 *ngIf="selectedTestData1.testDataSequence === 0">Primary</h5>
              <h5 *ngIf="selectedTestData1.testDataSequence > 0">Secondary {{ selectedTestData1.testDataSequence }} </h5>
            </div>
            <div class="common-table overflow m-2">
              <div class="extra-box" [hidden]="!(selectedTestData1.testData.length === 0)">Data not available</div>
              <table class="table table-sm" *ngIf="selectedTestData1.testData.length > 0">
                <thead>
                  <tr class="font-weight-bold">
                    <th>Key</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let syncedTestData of selectedTestData1.testData | orderBy:'asc':'keySequence'">
                    <td>{{syncedTestData.key}}</td>
                    <td>
                      <div [hidden]="syncedTestData.fromResponseExtractor && true !== syncedTestData.fromGlobalTestInput">
                        <span class="relay-word-wrap" title="{{syncedTestData.value}}">{{syncedTestData.value}}</span>
                      </div>
                      <div [hidden]="!(syncedTestData.fromResponseExtractor && syncedTestData.responseExtractor?.responseSource !== 'DOM')">
                        <span *ngIf="syncedTestData.affixConfig !== null">{{syncedTestData.affixConfig.prefix}}</span>
                        <span class="relay-word-wrap">{{syncedTestData.responseExtractor?.extractedValue}}</span>
                        <span *ngIf="syncedTestData.affixConfig !== null">{{syncedTestData.affixConfig.suffix}}</span>
                      </div>
                      <div [hidden]="!(syncedTestData.fromResponseExtractor && syncedTestData.responseExtractor?.responseSource === 'DOM')">
                        <span *ngIf="syncedTestData.affixConfig !== null">{{syncedTestData.affixConfig.prefix}}</span>
                        <span class="relay-word-wrap">{{syncedTestData.responseExtractor?.domExtractor?.extractedValue}}</span>
                        <span *ngIf="syncedTestData.affixConfig !== null">{{syncedTestData.affixConfig.suffix}}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div style="width: 50%;">
            <div style="text-align: center;">
              <h5 *ngIf="selectedTestData2.testDataSequence === 0">Primary</h5>
              <h5 *ngIf="selectedTestData2.testDataSequence > 0">Secondary {{ selectedTestData2.testDataSequence }} </h5>
            </div>
            <div class="common-table overflow m-2">
              <div class="extra-box" [hidden]="!(selectedTestData1.testData.length === 0)">Data not available</div>
              <table class="table table-sm" *ngIf="selectedTestData1.testData.length > 0">
                <thead>
                  <tr class="font-weight-bold">
                    <th>Key</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let syncedTestData of selectedTestData2.testData | orderBy:'asc':'keySequence'">
                    <td>{{syncedTestData.key}}</td>
                    <td>
                      <div [hidden]="syncedTestData.fromResponseExtractor && true !== syncedTestData.fromGlobalTestInput">
                        <span class="relay-word-wrap" title="{{syncedTestData.value}}">{{syncedTestData.value}}</span>
                      </div>
                      <div [hidden]="!(syncedTestData.fromResponseExtractor && syncedTestData.responseExtractor?.responseSource !== 'DOM')">
                        <span *ngIf="syncedTestData.affixConfig !== null">{{syncedTestData.affixConfig.prefix}}</span>
                        <span class="relay-word-wrap">{{syncedTestData.responseExtractor?.extractedValue}}</span>
                        <span *ngIf="syncedTestData.affixConfig !== null">{{syncedTestData.affixConfig.suffix}}</span>
                      </div>
                      <div [hidden]="!(syncedTestData.fromResponseExtractor && syncedTestData.responseExtractor?.responseSource === 'DOM')">
                        <span *ngIf="syncedTestData.affixConfig !== null">{{syncedTestData.affixConfig.prefix}}</span>
                        <span class="relay-word-wrap">{{syncedTestData.responseExtractor?.domExtractor?.extractedValue}}</span>
                        <span *ngIf="syncedTestData.affixConfig !== null">{{syncedTestData.affixConfig.suffix}}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
    <li title="Test Data" [ngbNavItem]="3">
      <a ngbNavLink>Difference</a>
      <ng-template ngbNavContent>
        <div style="display: flex;">
          <table class="table table-hover table-list-design" style="font-size : 11px; table-layout: fixed;">
            <thead>
              <th style="width: 25%;">Left Key</th>
              <th style="width: 25%; border-right: 1px solid #fff;">Left Value </th>
              <th style="width: 25%;">Right Key</th>
              <th style="width: 25%;">Right Value</th>
            </thead>
            <tr *ngFor="let entriesOnLeft of differenceData.entriesOnLeft">
              <td>{{entriesOnLeft.key}}</td>
              <td style="border-right: 1px solid grey; overflow: hidden; width: 25%">{{entriesOnLeft.leftValue}}</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr *ngFor="let entriesOnLeft of differenceData.entriesOnRight">
              <td>-</td>
              <td style="border-right: 1px solid grey; width: 25%; word-break: break-all;">-</td>
              <td>{{entriesOnLeft.key}}</td>
              <td style="width: 25%; word-break: break-all;">{{entriesOnLeft.rightValue}}</td>
            </tr>
            <tr *ngFor="let entriesDiffering of differenceData.entriesDiffering">
              <td>{{entriesDiffering.key}}</td>
              <td style="border-right: 1px solid grey; width: 25%; word-break: break-all;">{{entriesDiffering.leftValue}}</td>
              <td>{{entriesDiffering.key}}</td>
              <td style="width: 25%; word-break: break-all;">{{entriesDiffering.rightValue}}</td>
            </tr>
          </table>
        </div>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>